import { render, staticRenderFns } from "./bind-dialog.vue?vue&type=template&id=cfa921c8&scoped=true&"
import script from "./bind-dialog.vue?vue&type=script&lang=js&"
export * from "./bind-dialog.vue?vue&type=script&lang=js&"
import style0 from "./bind-dialog.vue?vue&type=style&index=0&id=cfa921c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa921c8",
  null
  
)

export default component.exports